import React from "react";
import { Typography, Button } from "@material-ui/core";
import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <div>
      <Typography variant="h2">404: page not found!</Typography>

      <Button variant="contained" color="primary" href="/">
        Go back to Home
      </Button>
    </div>
  );
};

export default NotFound;
